module.exports = __webpack_public_path__ + "img/google.ede5d6f.png";